import React from 'react';
import {Card, CardContent, Typography} from '@mui/material';
import {t} from 'i18next';

import AurAccordion from '../../common/aur-accordion/AurAccordion';
import AurSvgIcon from '../../common/aur-svg-icon/AurSvgIcon';

interface Analyzers {
  alphabeticalCharacters: string;
  analyzer: string;
  label: string;
  caseConversionFlag: boolean;
  id: string;
  name: string;
  stopWordsList: string[];
  stopwordList: Array<{word: string; someOtherField: string}>;
  whitespaceCharList: string;
  description: string;
}

interface AnalyzersFieldsProps {
  analyzerData: Analyzers[];
}

const AnalyzerSettings: React.FC<AnalyzersFieldsProps> = ({analyzerData}) => {
  const analyzersListData = analyzerData;
  return (
    <>
      <div className="analyzer-setting-header">
        <Typography className="typo-text headline3_size text metadata-title">
          {t(`indexes.viewSettings.analyzerSettings`)}{' '}
        </Typography>
        <Typography className="typo-text body1_size metadata-sub-title">
          {t(`indexes.viewSettings.analyzerSettinsDesc`)}{' '}
        </Typography>
      </div>

      <div className="analyzer-accordian-title">
        {analyzersListData.map((analyzers, index) => {
          const normalizedAnalyzer = analyzers.analyzer
            .toLowerCase()
            .replace(/\s+/g, '_');
          const label = t(`customIndexAnalyzers.${normalizedAnalyzer}.label`);
          const description = t(
            `customIndexAnalyzers.${normalizedAnalyzer}.description`
          );
          const titleContent = (
            <div style={{height: description.length ? '100px' : '45px'}}>
              <div className="accordian-title-logo">
                <Typography className="typo-text subhead2_size ">
                  {label}
                </Typography>
                {analyzers.analyzer?.toLowerCase().includes('cjk') ? (
                  <Typography className="typo-text body2_size language-logo">
                    <>
                      <AurSvgIcon src="images/chinese_flag.svg" />
                      Chinese
                    </>
                    <>
                      <AurSvgIcon src="images/japan_flag.svg" />
                      Japanese
                    </>
                    <>
                      <AurSvgIcon src="images/korean_flag.svg" />
                      Korean
                    </>
                  </Typography>
                ) : (
                  ''
                )}
              </div>
              <Typography className="custom-typo-text">
                {description}
              </Typography>
            </div>
          );

          return (
            <AurAccordion
              key={analyzers.id}
              fullWidth
              collapsed={index !== 0} // Ensure the first accordion is expanded by default
              title={titleContent}
              alertWarningIcon={false}
              toggleButtonTestId={`accordion-toggle-${index}`}
              toggleButtonExpandHint={t('customIndexAnalyzers.accordianHint')}
              toggleButtonCollapseHint={t('customIndexAnalyzers.accordianHint')}
              accordionAriaLabel={`${label} accordian`}
            >
              <Card elevation={0} className="analyzer-card-container">
                <CardContent>
                  <span className="card-content-analyzer">
                    <Typography className="typo-text subhead4_size color-mist-100 width-200">
                      {t(`indexes.viewSettings.stopWords`)}
                    </Typography>
                    <Typography className="typo-text body2_size color-mist-400">
                      {analyzers.stopWordsList?.length
                        ? analyzers.stopWordsList.join(', ')
                        : '-'}
                    </Typography>
                  </span>

                  <span className="card-content-analyzer">
                    <Typography className="typo-text subhead4_size color-mist-100 width-200">
                      {t(`indexes.viewSettings.alphabetChar`)}
                    </Typography>
                    <Typography className="typo-text body2_size color-mist-400">
                      {analyzers.caseConversionFlag
                        ? t(`indexes.viewSettings.ConvertToLowercase`)
                        : t(`indexes.viewSettings.RetainUppercase`)}
                    </Typography>
                  </span>

                  <span className="card-content-analyzer">
                    <Typography className="typo-text subhead4_size color-mist-100 width-200">
                      {t(`indexes.viewSettings.whitespaceChar`)}
                    </Typography>
                    <Typography className="typo-text body2_size color-mist-400">
                      {analyzers.whitespaceCharList
                        ? analyzers.whitespaceCharList
                        : '-'}
                    </Typography>
                  </span>
                </CardContent>
              </Card>
            </AurAccordion>
          );
        })}
      </div>
    </>
  );
};

export default AnalyzerSettings;
